import { createSlice } from '@reduxjs/toolkit'
import {RootState} from './store'
import { IUser } from '../interface/IUser'

const islogedIn = sessionStorage.getItem('login') !== null ? 
JSON.parse(sessionStorage.getItem('login') || ''):{}  ;
const now = new Date();
const initialState= {
  id: islogedIn.id || 0 ,
  isSignedIn: new Date(islogedIn.expirationDate) > now ? true : false || false,  
  userName: islogedIn.userName || 'unKnown',
  userLastName: '',
  usermail: 'unKnown@gmail.com',
  userRoleId: islogedIn.userRoleId ||  0,
  userRoleName: islogedIn.userRoleName ||  '',
  userRoles: islogedIn.userRoles ||  [{id: 1, role: 'Picker'}],
} as IUser
//console.log('islogedIn',islogedIn , initialState, now , new Date(islogedIn.expirationDate) > now);

const UserSlice = createSlice({
  name: 'userData',
  initialState,
  
  reducers: {
    decrementUser: (state, action) => {     
      state.isSignedIn = false;      
    },
    incrementUser: (state, action) => {       
      state.id = action.payload.id;
      state.userName = action.payload.userName;
      state.isSignedIn = action.payload.isSignedIn;
      state.userRoleName = action.payload.userRoleName; //"Administrator" ; //action.payload.UserUuid
      state.userRoleId = action.payload.userRoleId;
      state.userRoles = action.payload.userRoles;
      //return action.payload
      let dateTime = new Date()
      if (action.payload.isSignedIn) {dateTime.setHours(dateTime.getHours() + 4);}
      const  CredentialLogin = {
        ...state,
        expirationDate: dateTime
      }
      sessionStorage.setItem('login', JSON.stringify(CredentialLogin));
    }
  },
})



// Action creators are generated for each case reducer function
export const {  decrementUser, incrementUser } = UserSlice.actions
export const userData = (state: RootState)=>state
export default UserSlice.reducer